import { FC, Dispatch, SetStateAction } from "react";
import Award from "../ContractDocuments/CIO_Award.pdf";
import ConformedContract from "../ContractDocuments/CIO_Conformed_Contract.pdf";
import LaborCategoryDescriptions from "../ContractDocuments/CIO_Labor_Category_Descriptions.pdf";
import ContractorSiteRates from "../ContractDocuments/CIO_Contractor_Site_Rates.pdf";
import GovernmentSiteRates from "../ContractDocuments/CIO_Government_Site_Rates.pdf";

interface ICIOCollapsables {
  task_areas: boolean;
  documents: boolean;
}

interface IProps {
  isCollapsed: ICIOCollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ICIOCollapsables>>;
}

export const CIODocuments: FC<IProps> = ({ isCollapsed, setIsCollapsed }) => {
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            documents: !isCollapsed.documents,
          })
        }
        className="collapsable"
      >
        Contract Documents
        <i
          className={
            isCollapsed.documents ? "fas fa-caret-down" : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.documents ? "hidden" : ""
        }`}
      >
        <div className="contract-documents">
          <a
            href={Award}
            target="_blank"
            rel="noopener noreferrer"
            className="color-blue"
          >
            Contract Award
          </a>
          <a
            href={ConformedContract}
            target="_blank"
            rel="noopener noreferrer"
            className="color-blue"
          >
            Conformed Contract
          </a>
          <a
            href={LaborCategoryDescriptions}
            target="_blank"
            rel="noopener noreferrer"
            className="color-blue"
          >
            Labor Category Descriptions
          </a>
          <a
            href={ContractorSiteRates}
            target="_blank"
            rel="noopener noreferrer"
            className="color-blue"
          >
            Contractor Site Rates
          </a>
          <a
            href={GovernmentSiteRates}
            target="_blank"
            rel="noopener noreferrer"
            className="color-blue"
          >
            Government Site Rates
          </a>
        </div>
      </div>
    </div>
  );
};
